<template>
<div class="chapter">
<div class="inner_page">
<h2 class="no-break" id="pgepubid00008">PROLOGUE.<br class="calibre16"/>
<span class="cheaderfont">THE PROPHECY OF NATAS.</span></h2>
<blockquote class="calibre19"><div class="calibre2">
<p class="calibre3"><em class="calibre14">These are the last words of Israel di Murska, known in the days of strife as
Natas, the Master of the Terror, given to the Children of Deliverance dwelling in
the land of Aeria, in the twenty-fifth year of the Peace, which, in the reckoning
of the West, is the year nineteen hundred and thirty.</em></p>
</div>
</blockquote>
<p class="pcalibre drop-capi-m">MY life is lived, and the wings of the Angel of Death
overshadow me as I write; but before the last
summons comes, I must obey the spirit within
me that bids me tell of the things that I have
seen, in order that the story of them shall not die,
nor be disguised by false reports, as the years multiply and the
mists gather over the graves of those who, with me, have seen
and wrought them.</p>
<p class="calibre3">For this reason the words that I write shall be read
publicly in the ears of you and your children and your
children’s children, until they shall see a sign in heaven to tell
them that the end is at hand. No man among you shall take
away from that which I have written, nor yet add anything to
it; and every fifth year, at the Festival of Deliverance, which
is held on the Anniversary of Victory,<a id="FNanchor_1_1"></a><span class="fnanchor" href="#/Text/Section0039#Footnote_1_1" title="Link target outside of Sample">[1]</span> this writing of mine<span id="pgepubid00009" title="[2]"><a id="Page_2" title="[2]"></a></span>
shall be read, that those who shall hear it with understanding
may lay its warnings to heart, and that the lessons of the
Great Deliverance may never be forgotten among you.</p>
<p class="calibre3">It was in the days before the beginning of peace that I,
Natas the Jew, cast down and broken by the hand of the
Tyrant, conceived and created that which was known as the
Terror. The kings of the earth and their servants trembled
before my invisible presence, for my arm was long and my
hand was heavy; yet no man knew where or when I should
strike—only that the blow would be death to him on whom it
should fall, and that nowhere on earth should he find a safe
refuge from it.</p>
<p class="calibre3">In those days the earth was ruled by force and cunning,
and the nations were armed camps set one against the other.
Millions of men, who had no quarrel with their neighbours,
stood waiting for the word of their rulers to blast the fair
fields of earth with the fires of war, and to make desolate the
homes of those who had done them no wrong.</p>
<p class="calibre3">In the third year of the twentieth century, Richard Arnold,
the Englishman, conquered the empire of the air, and made
the first ship that flew as a bird does, of its own strength and
motion. He joined the Brotherhood of Freedom, then known
among men as the Terrorists, of whom I, Natas, was the
Master, and then he built the aerial fleet which, in the day of
Armageddon, gave us the victory over the tyrants of the earth.</p>
<p class="calibre3">At the same time, Alan Tremayne, a noble of the English
people, into whose soul I had caused my spirit to enter in order
that he might serve me and bring the day of deliverance
nearer, caused all the nations of the Anglo-Saxon race to join
hands, from the West unto the East, in a league of common
blood and kindred; and they, in the appointed hour, stood
between the sons and daughters of men and those who would
have enslaved them afresh.</p>
<p class="calibre3">The chief of these was Alexander Romanoff, last of the<span id="pgepubid00010" title="[3]"><a id="Page_3" title="[3]"></a></span>
Tsars, or Tyrants, of Russia, whose armies, leagued with those
of France, Italy, Spain, and certain lesser Powers, and assisted
by a great fleet of war-balloons that could fly, though slowly,
wherever they were directed, swept like a destroying pestilence
from the western frontiers of Russia to the eastern shores of
Britain; and when they had gained the mastery of Europe,
invaded England and laid siege to London.</p>
<p class="calibre3">But here their path of conquest was brought to an end, for
Alan Tremayne and his brothers of the Terror called upon the
men of Anglo-Saxondom to save their Motherland from her
enemies, and they rose in their wrath, millions strong, and fell
upon them by land and sea, and would have destroyed them
utterly, as I had bidden them do, but that Natasha, who was
my daughter and was known in those days as the Angel of the
Revolution, pleaded for the remnant of them, and they were
spared.</p>
<p class="calibre3">But the Russians we slew without mercy to the last man
of those who had stood in arms against us, saving only the
Tyrant and his princes and the leaders of his armies. These
we took prisoners and sent, with their wives and their children,
to die in their own prison-land in Siberia, as they had sent
thousands of innocent men and women to die before them.</p>
<p class="calibre3">This was my judgment upon them for the wrong that they
had done to me and mine, for in the hour of victory I spared
not those who had not known how to spare. Now they are
dead, and their graves are nameless. Their name is a byword
among men, for they were strong and they used their
strength to do evil.</p>
<p class="calibre3">So we made an end of tyranny among the nations, and
when the world-war was at length brought to an end, we disbanded
all the armies that were upon land and sank the warships
that were left upon the sea, that men might no more
fight with each other. War, that had been called honourable
since the world began, we made a crime of blood-guiltiness, for
which the life of him who sought to commit it should pay; and
as a crime, you, the children of those who have delivered the
nations from it, shall for ever hold it to be.</p>
<p class="calibre3"><span id="pgepubid00011" title="[4]"><a id="Page_4" title="[4]"></a></span></p>
<p class="calibre3">We leave you the command of the air, and that is the
command of the world; but should it come to pass—as in the
progress of knowledge it may well do—that others in the
world outside Aeria shall learn to navigate the air as you do,
you shall go forth to battle with them and destroy them
utterly, for we have made it known through all the earth that
he who seeks to build a second navy of the air shall be
accounted an enemy of peace, whose purpose it is to bring war
upon the earth again.</p>
<p class="calibre3">Forget not that the blood-lust is but tamed, not quenched,
in the souls of men, and that long years must pass before it
is purged from the world for ever. We have given peace on
earth, and to you, our children, we bequeath the sacred trust
of keeping it. We have won our world-empire by force, and
by force you must maintain it.</p>
<p class="calibre3">In the day of battle we shed the blood of millions without
ruth to win it, and so far the end has justified the means
we used. Since the sun set upon Armageddon, and the
right to make war was taken from the rulers of the nations,
we have governed a realm of peace and prosperity which
every year has seen better and happier than that which went
before.</p>
<p class="calibre3">No man has dared to draw the sword upon his brother, or
by force or fraud to take that which was not his by right. The
soil of earth has been given back to the use of her sons, and
their wealth has already multiplied a hundredfold on every
hand. Kings have ruled with wisdom and justice, and senates
have ceased their wranglings to soberly seek out and promote
the welfare of their own countries, and to win the respect and
friendship of others.</p>
<p class="calibre3">Yet many of these are the same men who, but a few years
ago, rent each other like wild beasts in savage strife for the
meanest ends; who betrayed their brothers and slaughtered
their neighbours, that the rich might be richer, and the strong
stronger, in the pitiless battle for wealth and power. They
have become peaceful and honest with each other, because we
have compelled them to be so, and because they know that the<span id="pgepubid00012" title="[5]"><a id="Page_5" title="[5]"></a></span>
penalty of wrong-doing in high places is destruction swift and
certain as the stroke of the hand of Fate itself.</p>
<p class="calibre3">They know that no man stands so high that our hand
cannot cast him down to the dust, and that no spot of earth is
so secret and so distant that the transgressor of our laws can
find in it a refuge from our vengeance. We stand between
the few strong and cunning who would oppress, and the many
weak and simple who could not resist them; and when we
are gone, you will hear the voice of duty calling you to take
our places.</p>
<p class="calibre3">When you stand where we do now, remember who you are
and the tremendous trust that is laid upon you. You are the
children of the chosen out of many nations, masters of the
world, and, under Heaven, the arbiters of human destiny.
You shall rule the world as we have ruled it for a hundred
years from now. If in that time men shall not have learnt
the ways of wisdom and justice, you may be sure that they
will never learn them, and deserve only to be left to their own
foolishness. Since the world began, the path of life has never
lain so fair and straight before the sons of men as it does
now, and never was it so easy to do the right and so hard to
do the wrong.</p>
<p class="calibre3">So, for a hundred years to come, you shall keep them in the
path in which we have set them, and those that would wilfully
turn aside from it you shall destroy without mercy, lest
they lead others into misery and bring the evil days upon
earth again.</p>
<p class="calibre3">At the twenty-fifth celebration of the Festival of Deliverance,
you shall give back the sceptre of the world-empire into
the hands of the children of those from whom we took it,—because
they wielded it for oppression, and not for mercy. At
that time you shall make it known throughout the earth that
men are once more free to do good or evil, according to
their choice, and that as they choose well or ill so shall they
live or die.</p>
<p class="calibre3">And woe to them in those days if, knowing the good, they
shall turn aside to do evil! Beyond the clouds that gather<span id="pgepubid00013" title="[6]"><a id="Page_6" title="[6]"></a></span>
over the sunset of my earthly life, I see a sign in heaven as
of a flaming sword, whose hilt is in the hand of the Master
of Destiny, and whose blade is outstretched over the habitations
of men.</p>
<p class="calibre3">As they shall choose to do good or evil, so shall that sword
pass away from them or fall upon them, and consume them
utterly in the midst of their pride. And if they, knowing the
good, shall elect to do evil, it shall be with them as of old the
Prophet said of the men of Babylon the Great: Their cities
shall be a desolation, a dry land and a wilderness; a land
wherein no man dwelleth, neither shall any son of man
pass thereby.</p>
<p class="calibre3">For from among the stars of heaven, whose lore I have
learned and whose voices I have heard, there shall come the
messenger of Fate, and his shape shall be that of a flaming fire,
and his breath as the breath of a pestilence that men shall feel
and die in the hour that it breathes upon them.</p>
<p class="calibre3">Out of the depths beyond the light of the sun he shall
come, and your children of the fifth generation shall behold his
approach. The sister-worlds shall see him pass with fear and
trembling, wondering which of them he shall smite, but if he
be not restrained or turned aside by the Hand which guides
the stars in their courses, it shall go hard with this world and
the men of it in the hour of his passing.</p>
<p class="calibre3">Then shall the highways of the earth be waste, and the
wayfaring of men cease. Earth shall languish and mourn for
her children that are no more, and Death shall reign amidst
the silence, sole sovereign of many lands!</p>
<p class="calibre3">But you, so long as you continue to walk in the way of
wisdom, shall live in peace until the end, whether it shall come
then or in the ages that shall follow. And if it shall come
then, you shall await it with fortitude, knowing that this life is
but a single link in the chain of existence which stretches
through infinity; and that, if you shall be found worthy, you
shall be taught how a chosen few among your sons and
daughters shall survive the ruin of the world, to be the parents
of the new race, and replenish the earth and possess it.</p>
<p class="calibre3"><span id="pgepubid00014" title="[7]"><a id="Page_7" title="[7]"></a></span></p>
<p class="calibre3">Out of the Valley of the Shadow of Death I stretch forth
my hands in blessing to you, the children of the coming time,
and pray that the peace which the men of the generation now
passing away have won through strife and toil in the fiery
days of the Terror, may be yours and endure unbroken unto
the end.</p>
<div class="figcenter3">
<img alt="" class="calibre13" id="id-224131918049767716" src="Images/img0002.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?7e503b51